import React, { Component ,Fragment  } from 'react';
import { apiService } from '../../common/apiCallService';
import { ReplayTable } from 'mygame-components'; 
import * as actions from '../../store/actions/index';
import { getCoins } from '../../common/commonService';
import Loading from '../Loading.js';
import Media from 'react-responsive'; 
import config from '../../common/config.js';
import { connect } from 'react-redux';
import { saveActivity } from '../../common/commonService.js'
let CarepetBackground = "/images/handReplay/PartyPoker/table_carpet.jpg";
//let CarepetBackground = "//mygame-dev.mypartypokerlive.com/images/handReplay/PartyPoker/table_carpet.jpg";
import ReplayerShareDialog from "./ReplayerShareDialog/ReplayerShareDialog"
var _ = require('lodash')
import "./css/multiReplayer-desktop.css";
import AllSelectedHandList from '../HandHistory/AllSelectedHandList';
import i18next from 'i18next'

class ReplayHand extends Component {
    constructor(props) {
        super(props);
        this.state = {
          playerList : [],
          loading : true,
          smallBlind: 0,
          bigBlind: 0,
          lostPlayers: [],
          wonPlayers: [],
          ritCards:[],
          rePlayerData: {
            slideIndex: 0,
            playStatus: false,
            currentSlide: {},
            slides: []
          },
          gameNo:"",
          game:"",
          gameType:"",
          timeoutStp: {},
          replayerSpeed: 1000,
          shareDialog: false,
          isShareDialogOpen : false,
          isShareToMomentReplay :false,
          isRIT:false,
          viewAllHands: false,
          booster:"N",
          boosterAmount:0,
          boosterType:'',
          currency:'USD'
        };
      }
    
      
      componentDidMount(){
        let clonedProps = JSON.parse(JSON.stringify(this.props));
        this.setUpReplayerData(clonedProps.gameNo, clonedProps.playerAlias, clonedProps.accountName,
          clonedProps.fromDate, clonedProps.toDate, clonedProps.gameType, clonedProps.partitionDate,clonedProps.sharedType,clonedProps.sharedId);
        if (localStorage.getItem("loggedInType") === "Danskespil") {
          CarepetBackground = "/images/handReplay/Danskespil/table_carpet.jpg";
        }
      }

      componentWillReceiveProps(nextProps){
        if(this.props.rangeBarValue !== nextProps.rangeBarValue){
          this.setState({ replayerSpeed: parseInt(nextProps.rangeBarValue.value) });
        }
      }
    

      setUpReplayerData = (gameNo, playerAlias, accountName, fromDate, toDate, gameType, partitionDate,sharedType,sharedId) => {
        apiService(config.baseUrl + '/pokerWatch/handReplayer',
      { gameNo, playerAlias,fromDate,toDate,gameType,partitionDate,accountName,sharedId,sharedType},
      (data) => {
            this.setState({ loading: false });
            let actionDtls = [];
            let sbFlag = 0;
            this.setState({
              currency: data.currency,
              smallBlind: data.gameDtls.gameInfo_blinds_small,
              bigBlind: data.gameDtls.gameInfo_blinds_big,
              game:data.gameDtls.game,
              gameNo:data.gameDtls.gameNo,
              gameType:data.gameDtls.gameInfo_gameType,
              isRIT : data.isRIT,
              booster:data.booster || 'N',
              boosterAmount:data.boosterAmount||0,
              boosterType:data.boosterType || ''
            });
            // console.log("-------------------------data--------",data);  
            data.actionDtlsList.map((action) => {
              // console.log("------------cards------------",action.cards)
              if (action.action == 'smallBlind') sbFlag++;
              if (sbFlag <= 1) actionDtls.push(action);
            });
            //sort player list as per seat position
            data.playerDtlsList = _.sortBy(data.playerDtlsList,"seat")
            this.processRawData(data.handSummary);
            // this.processRawData(data.rawData);
            this.setState({ playerList: JSON.parse(JSON.stringify(data.playerDtlsList)) },
              () => {
                // this.generateSlides(data.playerDtlsList, actionDtls, data.playerAlias);
                if(this.props.slideIndex && parseInt(this.props.slideIndex) != 0){
                  this.generateSlidesUpToSlideIndex(data.playerDtlsList, actionDtls, data.playerAlias);
                }else{
                  this.generateSlides(data.playerDtlsList, actionDtls, data.playerAlias);
                }
                let { rePlayerData } = this.state;
                rePlayerData.currentSlide = JSON.parse(JSON.stringify(rePlayerData.slides[0]));
                setTimeout(() => {
                  this.setState({ loading: false });
                  this.play();
                }, 2000);
              }
            );
    
          }, () => {
            this.setState({ loading: false });
          });
      }

      processRawData = (handSummary) => {
        this.state.lostPlayers = []
        this.state.wonPlayers = []
        let secondBoardFlag = false;
        
        if (handSummary) {
          handSummary.map((line) => {
            if (line.indexOf('SECOND Board') !== -1) {
              secondBoardFlag = true;
            }
            if (line.indexOf('collected') !== -1 && line.indexOf('lost') === -1) {
              if (secondBoardFlag) {
                let temp = {}
                temp.name = line.split('balance')[0].trim()
                temp.name = temp.name.split(" ")[0];
                temp.collectedAmt = Number(/(\d+\.?\d*)/g.exec(line.split('collected ')[1])[1].trim())
                if (line.indexOf('] [') !== -1) temp.cardDtls = /\[(.*)]/g.exec(line)[1].trim().split('] [')[1]
                
                if(temp.cardDtls){
                 this.setState({ritCards : [{...temp}]})
                }
              }else{
                let temp = {}
                temp.name = line.split('balance')[0].trim()
                temp.name = temp.name.split(" ")[0];
                temp.collectedAmt = Number(/(\d+\.?\d*)/g.exec(line.split('collected ')[1])[1].trim())
                if (line.indexOf('] [') !== -1) temp.cardDtls = /\[(.*)]/g.exec(line)[1].trim().split('] [')[1]
                // this.state.wonPlayers.push(temp)
                if(temp.cardDtls){
                  this.setState({wonPlayers : [{...temp}]})
                }
                
              }
            } else if (line.indexOf('lost') !== -1 && line.indexOf('] [') !== -1) {
              let temp = {}
              temp.name = line.split('balance')[0].trim()
              temp.name = temp.name.split(" ")[0];
              temp.lostAmt = Number(/(\d+\.?\d*)/g.exec(line.split('lost ')[1])[1].trim())
              temp.collectedAmt = 0
              if (line.indexOf('collected') !== -1) temp.collectedAmt = Number(/(\d+\.?\d*)/g.exec(line.split('collected ')[1])[1].trim())
              if (line.indexOf('] [') !== -1) temp.cardDtls = /\[(.*)]/g.exec(line)[1].trim().split('] [')[1]
              this.state.lostPlayers.push(temp)
            }

          })
        }
      }

      generateSlidesUpToSlideIndex = (initPlayerList,initActionList,playerAlias) => {
        this.addSlide(this.generateFirstSlide(initPlayerList,playerAlias));
        let anteFlag = true;
        let riverCount = 0;
        initActionList.map((action,index) => { 
           let workingSlide = this.getLastSlide();
          // console.log("this.state.rePlayerData.slideIndex",this.state.rePlayerData.slides.length,this.props.slideIndex);
           if(parseInt(this.state.rePlayerData.slides.length) <= parseInt(this.props.slideIndex)){
           let slidePlayer = workingSlide.players.filter((p) => {
             if(p.name === action.actor){
            return p;
          }});
          if(slidePlayer){
          if(workingSlide.action && action.action === workingSlide.action.action && action.actor === "dealer" && action.action === "flop"){
            let slide = this.state.rePlayerData.slides[this.state.rePlayerData.slides.length - 1];
            
            if(riverCount > 0 && this.state.isRIT){
              slide.ritCards = slide.ritCards+","+action.cards.replace(/^\s+/,"");
            }else{
              slide.cards = slide.cards+","+action.cards.replace(/^\s+/,"");
            }
          }else if(action.action === "show" && workingSlide.action.sequence !== action.sequence){
            if(workingSlide.cardsLength > 2){
              slidePlayer[0].cards = initActionList[index].cards +initActionList[index+1].cards+initActionList[index+2].cards+initActionList[index+3].cards;
            }else{
              slidePlayer[0].cards = initActionList[index].cards +initActionList[index+1].cards;
            }
              
              workingSlide.action = action;
              this.addSlide(workingSlide);
          }else if(action.action === "hole cards" && workingSlide.action.sequence !== action.sequence){
            if(workingSlide.cardsLength > 2){
              slidePlayer[0].cards = initActionList[index].cards +","+initActionList[index+1].cards+","+initActionList[index+2].cards+","+initActionList[index+3].cards;
            }else{
              slidePlayer[0].cards = initActionList[index].cards +","+initActionList[index+1].cards;
            }
            workingSlide.action = action;
            workingSlide.showCards = true;
            this.addSlide(workingSlide);
          }else if(action.action === "show" && workingSlide.action.sequence === action.sequence){
            return;
          }else if(action.action === "hole cards" && workingSlide.action.sequence === action.sequence){
            return;
          }else if(action.action === "ante"){
            if(anteFlag){
               workingSlide.players.map((p) => {
              if(this.state.gameType === "tournament"){
                workingSlide.pot = parseInt(workingSlide.pot) + parseInt(action.amount);
              }else{
                workingSlide.pot = parseFloat(workingSlide.pot) + parseFloat(action.amount);
                workingSlide.pot = workingSlide.pot.toFixed(2);
              }
               
              });
              workingSlide.hiddenPot = workingSlide.pot;
              workingSlide.action = action;
              anteFlag = false;
              // console.log("workingSlide",workingSlide);
              this.addSlide(workingSlide);
            }else{
              return;
            }
            
          }else{
            this.addSlide(this.convertActionToSlide(action,riverCount)); 
          }
        }
        if(action.action === "river"){
          riverCount = riverCount + 1;
         }
        }
        this.pause()
          });
      }

      generateSlides = (initPlayerList,initActionList,playerAlias) => {
        this.addSlide(this.generateFirstSlide(initPlayerList,playerAlias));
        let anteFlag = true;
        let riverCount = 0;
        initActionList.map((action,index) => { 
           let workingSlide = this.getLastSlide();
           
           let slidePlayer = workingSlide.players.filter((p) => {
             if(p.name === action.actor){
            return p;
          }});
          if(slidePlayer){
          if(workingSlide.action && action.action === workingSlide.action.action && action.actor === "dealer" && action.action === "flop"){
            let slide = this.state.rePlayerData.slides[this.state.rePlayerData.slides.length - 1];
            
            if(riverCount > 0 && this.state.isRIT){
              slide.ritCards = slide.ritCards+","+action.cards.replace(/^\s+/,"");
            }else{
              slide.cards = slide.cards+","+action.cards.replace(/^\s+/,"");
            }
          }else if(action.action === "show" && workingSlide.action.sequence !== action.sequence){
            if(workingSlide.cardsLength > 2){
              slidePlayer[0].cards = initActionList[index].cards +","+initActionList[index+1].cards+initActionList[index+2].cards+","+initActionList[index+3].cards;
            }else{
              slidePlayer[0].cards = initActionList[index].cards+"," +initActionList[index+1].cards;
            }
              
              workingSlide.action = action;
              this.addSlide(workingSlide);
          }else if(action.action === "hole cards" && workingSlide.action.sequence !== action.sequence){
            if(workingSlide.cardsLength > 2){
              slidePlayer[0].cards = initActionList[index].cards +","+initActionList[index+1].cards+","+initActionList[index+2].cards+","+initActionList[index+3].cards;
            }else{
              slidePlayer[0].cards = initActionList[index].cards +","+initActionList[index+1].cards;
            }
            workingSlide.action = action;
            workingSlide.showCards = true;
            this.addSlide(workingSlide);
          }else if(action.action === "show" && workingSlide.action.sequence === action.sequence){
            return;
          }else if(action.action === "hole cards" && workingSlide.action.sequence === action.sequence){
            return;
          }else if(action.action === "ante"){
            if(anteFlag){
               workingSlide.players.map((p) => {
              if(this.state.gameType === "tournament"){
                workingSlide.pot = parseInt(workingSlide.pot) + parseInt(action.amount);
              }else{
                workingSlide.pot = parseFloat(workingSlide.pot) + parseFloat(action.amount);
                workingSlide.pot = workingSlide.pot.toFixed(2);
              }
               
              });
              workingSlide.hiddenPot = workingSlide.pot;
              workingSlide.action = action;
              anteFlag = false;
              // console.log("workingSlide",workingSlide);
              this.addSlide(workingSlide);
            }else{
              return;
            }
            
          }else{
            this.addSlide(this.convertActionToSlide(action,riverCount)); 
          }
        }
        if(action.action === "river"){
          riverCount = riverCount + 1;
         }
          });

          this.addSlide(this.generateLastSlide(this.state.lostPlayers, this.state.wonPlayers));
          if(this.state.isRIT){
            this.addSlide(this.generateLastSlideForRit(this.state.lostPlayers, this.state.ritCards));
          }
      }
      generateLastSlideForRit = (lostPlayers, wonPlayers) => {
        let slide = this.generateLastSlide(lostPlayers, wonPlayers);
        slide.isLastSlide = true;
        return slide
      }
      generateLastSlide = (lostPlayers, wonPlayers) => {
        let slide = this.getLastSlide();
        let tempDesc = '';
        lostPlayers.map( async(player) => {
          let slidePlayer = slide.players.filter((p) => {if(p.name === player.name){
             p.amount = 0;
            return p;
          }});
          if(slide.cashout_plyrs.some(plyr=>plyr.name === slidePlayer[0].name) && player.collectedAmt>0 ){
            slidePlayer[0].amount = player.collectedAmt;
            slide.pot = 0;
            slide.hiddenPot = -1;
            slidePlayer[0].startStack = parseFloat(slidePlayer[0].startStack) + parseFloat(player.collectedAmt);
            slidePlayer[0].startStack = slidePlayer[0].startStack.toFixed(2);
          }
          tempDesc = `${tempDesc} ${slidePlayer[0].name} : lost(${player.lostAmt})${(player.cardDtls) ? " with" + player.cardDtls : ""}\n`;
        });
    
        wonPlayers.map( async(player) => {
          let slidePlayer = slide.players.filter((p) => {if(p.name === player.name){
            return p;
          }});
          slidePlayer[0].amount = player.collectedAmt;
          slide.pot = 0;
          slide.hiddenPot = -1;
          if(this.state.gameType === "tournament"){
            slidePlayer[0].startStack = parseInt(slidePlayer[0].startStack) + parseInt(player.collectedAmt);
          }else{
            slidePlayer[0].startStack = parseFloat(slidePlayer[0].startStack) + parseFloat(player.collectedAmt);
            slidePlayer[0].startStack = slidePlayer[0].startStack.toFixed(2);
          }
          slide.highLightCard = player.cardDtls ? player.cardDtls.split('-- ')[1].split(',') : null;
          tempDesc = `${tempDesc} ${slidePlayer[0].name} : won(${slidePlayer[0].amount})${(player.cardDtls) ? " with" + player.cardDtls : ""}`;
        });
        slide.description = slide.description + '\n' + tempDesc;
        if(!this.state.isRIT)
          slide.isLastSlide = true;
        return slide;
      }

      getSeatIndexByName = (seats, name) => {
        var index= -1;
        for (var i = 0; i < seats.length; ++i) {
          if (seats[i].name === name) {
              index = i;
              break;
          }
        }
        return index;
      }

      convertActionToSlide = (action,riverCount) => {
        // console.log("action",action);
        let workingSlide = this.getLastSlide();
        if(riverCount > 0 && this.state.isRIT){
         workingSlide.isRIT = true
        }else{
         workingSlide.isRIT = false
        }
        let index = this.getSeatIndexByName(workingSlide.players, action.actor);
        this.upadateDescription(workingSlide, index, action);
        if(workingSlide){
         workingSlide.action = action;
         workingSlide.players.map((player) => {
           let p = {...player};
          if(p.name === action.actor){
            if(action.action!="cashout" && action.amount){
              if(parseFloat(p.startStack) > action.amount){
                if(this.state.gameType === "tournament"){
                  player.startStack  = parseInt(p.startStack) - parseInt(action.amount);
                }else{
                  player.startStack  = (parseFloat(p.startStack) - action.amount).toFixed(2);
                }
              }else{
                player.startStack = 0;
              }
              if(this.state.gameType === "tournament"){
                workingSlide.pot = parseInt(workingSlide.pot) + parseInt(action.amount);
                player.amount = player.amount ? parseInt(player.amount) + parseInt(action.amount) : parseInt(action.amount);
                
              }else{
                workingSlide.pot = parseFloat(workingSlide.pot) + parseFloat(action.amount);
                workingSlide.pot = workingSlide.pot.toFixed(2);
                player.amount = player.amount ? parseFloat(player.amount) + parseFloat(action.amount) :parseFloat(action.amount);
                player.amount = player.amount.toFixed(2);
              }
              
            }
            if(action.action == 'fold'){
              player.status = "in-active"
           /*   if(!player.amount){
                player.amount = 0;
              }
              if(this.state.gameType === "tournament"){
                workingSlide.pot = parseInt(workingSlide.pot) + parseInt(player.amount);
              }else{
                workingSlide.pot = (parseFloat(workingSlide.pot) + parseFloat(player.amount)).toFixed(2);
              }
              
              player.amount = 0;*/
            }
            
            if(action.action === 'cashout' && action.cashoutOpted){
              
              workingSlide.cashout_plyrs.push({"name":action.actor,"cashout_amt":action.amount});
              
            }
          
          }
          if(action.action === 'flop' ||action.action === 'turn' || action.action === 'river'|| action.action === 'cashout'){
           
            player.amount = null;
          }

        })
        if(action.action === 'flop'){
          if(riverCount > 0 && this.state.isRIT){
            workingSlide.ritCards = action.cards;
          }else{
            workingSlide.cards = action.cards;
          }
          
          if(this.state.gameType === "tournament"){
            workingSlide.hiddenPot = parseInt(workingSlide.pot);
          }else{
            workingSlide.hiddenPot = parseFloat(workingSlide.pot).toFixed(2);
          }
          
        }
        if((action.action === 'turn') || (action.action === 'river')){
          if(riverCount > 0 && this.state.isRIT){
            if(workingSlide.ritCards){
              workingSlide.ritCards = workingSlide.ritCards+","+action.cards;
            }else{
              if((action.action === 'turn')){
                workingSlide.ritCards = ",,,"+action.cards;
              }else{
                workingSlide.ritCards = ",,,,"+action.cards;
              }
              
            }
            
          }else{
            workingSlide.cards = workingSlide.cards+","+action.cards;
          }
          if(this.state.gameType === "tournament"){
            workingSlide.hiddenPot = parseInt(workingSlide.pot);
          }else{
            workingSlide.hiddenPot = parseFloat(workingSlide.pot).toFixed(2);
          }
          
        }
      }
        return workingSlide;
      }

      upadateDescription = (workingSlide, index, action) => {

        let amtDescp = '';
        if (action.amount) amtDescp = action.amount;
    
        let currDescp = '';
        if (index == -1) currDescp = '\n' + 'Dealer' + ': ' + action.action + " " + amtDescp;
        else {
          currDescp = workingSlide.seats ?  '\n' + workingSlide.seats[index].name + ': ' + action.action + " " + amtDescp : "";
        }
    
        if (action.cards && action.action != 'not show') currDescp = currDescp + ' ' + action.cards;
    
        workingSlide.description = workingSlide.description + currDescp;
      }

      // getSeatIndexByName = (seats, name)=> {
      //   return seats.findIndex((seat) => seat.alias == name);
      // }

      getLastSlide = () => {
        return JSON.parse(JSON.stringify(this.state.rePlayerData.slides[this.state.rePlayerData.slides.length - 1]));
      }

      addSlide = (slide) => {
        console.log("slide",slide);
        if (slide) {
          // console.log(`Adding slide with slide id ${slide.slideID}`);
          let { rePlayerData } = this.state;
          rePlayerData.slides.push(slide);
          this.setState({rePlayerData:rePlayerData});
        }
      }

      generateFirstSlide = (playerList,playerAlias) => {
        let slide = {};
        slide = {
          pot: 0,
          hiddenPot:0,
          slideID: 1,
          players:[],
          cards:null,
          action:null,
          description:"",
          cardsLength:0,
          showCards:false,
          ritCards:null,
          highLightCard :null,
          cashout_plyrs:[]
        };
        let player = playerList.filter(p => p.name === playerAlias)
        slide.cardsLength = player[0].cards ? player[0].cards.split(',').length:[].length;
        playerList.map((player,index) => {
          let p = {...player};
          p.playerName=p.name;
          if(parseFloat(player.startStack) > 0){
            p.status = "active";
            if(p.cards && p.cards.length > 0){
              p.hero = true;
            }
          }else{
            p.status = "in-active";
          }
          slide.players.push(p);
        })
        
        return slide;
      }

      play = ()=> {
       //console.log("in play")
        let { rePlayerData } = this.state;
        rePlayerData.playStatus = true;
        // console.log("current slide",rePlayerData.currentSlide);
        // console.log("last slide",this.state.rePlayerData.slides.length,this.state.rePlayerData.slides[this.state.rePlayerData.slides.length - 1]);
        // console.log("status play",rePlayerData.currentSlide == rePlayerData.slides[rePlayerData.slides.length-1])
        if(rePlayerData.currentSlide.hiddenPot === - 1){
          this.refresh();
        }else{
          console.log("inside else",this.props.slideIndex,this.state.rePlayerData.slideIndex)
          if(parseInt(this.props.slideIndex)>0 && parseInt(this.state.rePlayerData.slideIndex) == parseInt(this.props.slideIndex)){
            this.openShareToMomentReplayModal();
            //console.log("inside openShareToMomentReplayModal")
          }else{
            //console.log("inside openShareToMomentReplayModal else")
            this.continue();
          }
        }
        
      }
     
      continue = ()=> {
        // console.log("continue",this.state.rePlayerData.playStatus);
        
        this.setState({
          timeoutStp: setTimeout(() => {
            // console.log("this.state.replayerSpeed",this.state.replayerSpeed)
            if (this.state.rePlayerData.playStatus) {
              this.nextSlide();
              this.continue();
            }
          }, this.state.replayerSpeed)
        });
      }

      refresh = () => {
        clearTimeout(this.state.timeoutStp);
        // this.setState({ replayerSpeed: 1000 })
        this.pause();
        this.setState({isShareToMomentReplay: false})
        let { rePlayerData } = this.state;
        rePlayerData.currentSlide.hiddenPot = -1;
        rePlayerData.slideIndex = 0;
        rePlayerData.currentSlide = JSON.parse(JSON.stringify(rePlayerData.slides[rePlayerData.slideIndex]))
        this.setState({rePlayerData:rePlayerData});
        this.play();
      }

      stop = () => {
        clearTimeout(this.state.timeoutStp);
        
        let { rePlayerData } = this.state;
        rePlayerData.slideIndex = 0;
        rePlayerData.currentSlide =  JSON.parse(JSON.stringify(rePlayerData.slides[0]));
        rePlayerData.playStatus = false;
        rePlayerData.currentSlide.hiddenPot = -1;
        this.setState({rePlayerData:rePlayerData});
        
         
      }

      pause = () => {
       // console.log("rePlayerData",this.state.rePlayerData);
        let rePlayerData = this.state.rePlayerData;
        rePlayerData.playStatus = false
        this.setState({rePlayerData:rePlayerData});
        this.forceUpdate();
      }

       //playerFunction
  nextSlide = ()=> {
    
    let { rePlayerData } = this.state;
    // console.log("in next slide",rePlayerData);
    let noOfSlides = rePlayerData.slides.length;
    // console.log("noOfSlides",noOfSlides);
    
    if (rePlayerData.slideIndex != (noOfSlides)) {
      // console.log("rePlayerData.slideIndex",rePlayerData.slideIndex);
      rePlayerData.slideIndex++;
          // console.log("currSlide",JSON.parse(JSON.stringify(rePlayerData.slides[rePlayerData.slideIndex])));
          if(rePlayerData.slides[rePlayerData.slideIndex]){
          rePlayerData.currentSlide = JSON.parse(JSON.stringify(rePlayerData.slides[rePlayerData.slideIndex]));
          if (rePlayerData.slideIndex == (noOfSlides)) {
            rePlayerData.playStatus = false;
            
            if (this.props.slideEnded) this.props.slideEnded();
          }
        }
        setTimeout(() => {
        this.setState({rePlayerData:rePlayerData});
      }, 10);
      this.forceUpdate();
      
    } else {
      // console.log("No more Slides");
      let rePlayerData = { ...this.state.rePlayerData };
      rePlayerData.playStatus = false;
      this.setState({ rePlayerData :rePlayerData });
      if (this.props.slideEnded) this.props.slideEnded();
    }
  }

  prevSlide = () => {
    let { rePlayerData } = this.state;

    if (rePlayerData.slideIndex > 0) {
      rePlayerData.slideIndex--;
      rePlayerData.currentSlide = JSON.parse(JSON.stringify(rePlayerData.slides[rePlayerData.slideIndex]))
      setTimeout(() => {
      this.setState({ rePlayerData :rePlayerData });
    }, 10);
      
    }
  }

  stepForward = () => {
    let rePlayerData = this.state.rePlayerData;
    rePlayerData.playStatus = false;
    this.setState({rePlayerData:rePlayerData});
    this.forceUpdate()
    this.pause();
    this.nextSlide()
  }

  stepBackward = () => {
    let rePlayerData = this.state.rePlayerData;
    rePlayerData.playStatus = false;
    this.setState({rePlayerData:rePlayerData});
    this.forceUpdate()
    this.pause();
    this.prevSlide();
  }

  openShareDialog = () => {
    saveActivity({
      hit_page: 'HandReplayer',
      hit_type: 'ShareReplayerOpen',
      hit_attribute1: this.props.gameTypeForTitle,
      hit_attribute2: this.state.gameNo,
      hit_attribute3: this.props.playerAlias,
    })
    this.pause();
    this.setState({isShareDialogOpen: true})
  }

  closeShareDialog= () => {
    this.play();
    this.setState({isShareDialogOpen: false})
  }
  openShareToMomentReplayModal = () =>{
    this.setState({isShareToMomentReplay: true})
  }
  closeShareToMomentReplayModal = () =>{
    this.pause();
    this.setState({isShareToMomentReplay: false})
  }

      render() {
        let showTurnFlag = false;
        if (navigator) {
          let nav = navigator
          // console.log("nav.appVersion",nav.appVersion)
          if (nav.appVersion.includes("Mobile") || nav.appVersion.includes("iPad") || nav.appVersion.includes("iPhone")) {
            showTurnFlag = true;
          } else {
            showTurnFlag = false;
          }
        }
        // console.log(this.props)
        return (
         <div className={this.props.replayerScreen === "shared" ? "ReplayerContaintMainWrapper" : ""} style={{ 
          width: "100%", 
          height: "100%",
          background:  `url("${CarepetBackground}")`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover"
        }}>
           {this.state.loading ? <Loading /> : null}
            <Media query="(orientation: portrait)">
              {matches => matches && showTurnFlag ? null : <span>{this.state.viewAllHands && <AllSelectedHandList
                handList={this.props.selectedHandList}
                setStarFlagOfHnad={this.props.setStarFlagOfHnad}
                currentReplayerHandIndex={this.props.currentReplayerHandIndex}
                replayerScreen={this.props.replayerScreen}
                showStarOption={this.props.replayerScreen === 'shared' ? false : true}
                openThisHand={(index) => {
                  this.setState({ viewAllHands: false })
                  this.props.openThisHand(index);
                }}
                onCloseViewAllHands={() => {
                  this.setState({ viewAllHands: false })
                }}
              />}
              </span>}
            </Media>
           {this.state.isShareToMomentReplay ? <div className={`rs-modal`} >
              
              <div style={{ display: 'grid', justifyItems: 'center' }}>
              <div className='fit-content report-share-modal-content shareToMomentDiv' style={{ background: 'white', borderRadius: '5px' }}>
                  <div className="shareToMomentCpntentDiv">
                    <div className="shareToMomentHeaderDiv">{i18next.t("lable.handWasSharedToThisMoment")}<span style={{float:"right"}}><i className="fa fa-times" onClick={() => this.closeShareToMomentReplayModal()}></i></span></div>
                  <div className="share-up-to-a-specif">{i18next.t("lable.wouldYouLikeToReplay")}</div>
                  </div>
                  <div><button className='replayButton' onClick={() => this.refresh()}>
                  {i18next.t("lable.replayHand")}
                  </button> 
                  {this.props.loginStatus ? null : 
                  <button className='learnMoreReplay' >
                  <a style={{color:"#E8480D"}}  href='https://poker.partypoker.com/en/my-game?_nocache=1&_mode=preview'>{i18next.t("lable.learnMore")}</a>
                 </button>}
                 </div>
              </div>
          </div> 
                
            </div> : null}
            <Media query="(orientation: portrait)">
              {matches => matches && showTurnFlag ? null : <Media query="(min-width: 900px; max-width: 900px)" >
                {matches => matches ? null : (<span><span style={{ color: "white", fontSize: "2vh", fontWeight: "bold", justifySelf: 'left', marginLeft: "10px" }}>
                  <span>
                    {this.props.isMultipleHands ?
                      <div className="MultiHandReplayTableInfoWrapper">
                        <div className="MultiHandReplay_HandCountsAndViewHandsWrapper">
                          <span className="MultiHandReplay_handCount">{i18next.t("lable.hand")} {this.props.currentReplayerHandIndex + 1} {i18next.t("lable.of")} {this.props.selectedHandCount}</span>
                          <span className="MultiHandReplay_viewHands" onClick={() => {
                            this.pause();
                            this.setState({ viewAllHands: true })
                          }}>{i18next.t("lable.viewHands")}</span>
                        </div>
                        <div className="MultiHandReplayTableInfo">
                          {i18next.t("lable.table")+" "  + this.state.game}
                        </div>
                      </div>
                      :
                      <span style={{float:"left", paddingLeft: "15px"}}>
                        {i18next.t("lable.table")+" " + this.state.game}
                      </span>}
                  </span>

                </span>
                  {this.props.isMultipleHands
                    ? <span style={{ color: "white", fontSize: "1.3vh", fontWeight: "bold", position: "absolute", right: "14px", top: "5px", marginRight: "10px" }}> {i18next.t("lable.hand")+"# " +  this.state.gameNo}</span> 
                    : <span style={{ color: "white", fontSize: "1.3vh", fontWeight: "bold", float: 'right', marginRight: "10px" }}> {i18next.t("lable.hand")+"# " +  this.state.gameNo}</span>}
                </span>
                )
                }</Media>}
            </Media>
            <Media query="(orientation: portrait)">
              {matches => matches && showTurnFlag ? null : <Media minWidth={869} maxWidth={860}>
                {this.props.isMultipleHands &&
                  <div className="MultiHandReplayTableInfoWrapper">
                    <div className="MultiHandReplay_HandCountsAndViewHandsWrapper">
                      <span className="MultiHandReplay_handCount">{i18next.t("lable.hand")} {this.props.currentReplayerHandIndex + 1} {i18next.t("lable.of")} {this.props.selectedHandCount}</span>
                      <span className="MultiHandReplay_viewHands" onClick={() => {
                        this.pause();
                        this.setState({ viewAllHands: true })
                      }}>{i18next.t("lable.viewHands")}</span>
                    </div>
                    <div className="MultiHandReplayTableInfo">
                    {i18next.t("lable.table")+" " + this.state.game}
                    </div>
                  </div>}
              </Media>}
            </Media>
            <Media query="(orientation: portrait)">
              {matches => matches && showTurnFlag ? null : <Media maxWidth={68}>
                {this.props.isMultipleHands &&
                  <div className="MultiHandReplayTableInfoWrapper">
                    <span className="MultiHandReplayTableInfoOnlyWrapper">
                      <span className="MultiHandReplay_handCount">{i18next.t("lable.hand")} {this.props.currentReplayerHandIndex + 1} {i18next.t("lable.of")} {this.props.selectedHandCount}</span>
                      <div className="MultiHandReplayTableInfo">
                      {"- "+i18next.t("lable.table")+" " + this.state.game}
                      </div>
                    </span>
                    <span className="MultiHandReplay_viewHands MultiHandReplay_viewHands_mobile" onClick={() => {
                      this.pause();
                      this.setState({ viewAllHands: true })
                    }}>{i18next.t("lable.viewHands")}</span>
                  </div>}
              </Media>}
            </Media>
           {/* <span className="titleCss" style={{ justifySelf: 'left'}}> {"Table "+this.state.game}</span> 
           <span className="titleCss" style={{ float: 'right'}}> {"Hand# "+this.state.gameNo}</span>  */}
           
           {/* {this.state.playerList.length > 0 ? <ReplayTable playerList={this.state.playerList}></ReplayTable> : null} */}
           {this.state.rePlayerData.currentSlide ? <ReplayTable 
           slide={this.state.rePlayerData.currentSlide}
            isMultipleHands={this.props.isMultipleHands}
            prevHand={this.props.prevHand}
            nextHand={this.props.nextHand}
            selectedHandCount={this.props.selectedHandCount}
            currentReplayerHandIndex={this.props.currentReplayerHandIndex}
            replayerScreen={this.props.replayerScreen ? this.props.replayerScreen :null}
            onClose={this.props.onClose} 
            pause={this.pause}
            play={this.play}
            playStatus={this.state.rePlayerData.playStatus}
            stepBackward={this.stepBackward}
            stepForward={this.stepForward}
            refresh={this.refresh}
            stop={this.stop}
            gameNo={this.state.gameNo}
            game={this.state.game}
            handDtls={this.props.handDtls}
            isShareDialogOpen={this.state.isShareDialogOpen}
            closeShareDialog={this.closeShareDialog}
            partitionDate={this.props.partitionDate}
            accountName={this.props.accountName}
            gameTypeForTitle={this.props.gameTypeForTitle}
            openShareDialog={this.openShareDialog}
            selectedHandList={this.props.selectedHandList}
            smallBlind={this.state.smallBlind}
            getRangeBarValue={this.props.getRangeBarValue}
            getCoins={getCoins}
            ReplayerShareDialog={ReplayerShareDialog}
            bigBlind={this.state.bigBlind}
            sharedId={this.state.sharedId}
            sharedType={this.state.sharedType}
            currency={this.state.currency}
            gameType={this.props.gameType ? this.props.gameType : ''}
            slideIndex={this.state.rePlayerData.playStatus == false ? this.state.rePlayerData.slideIndex : '' }
            slideLength={this.state.rePlayerData.slides.length}
            booster={this.state.booster}
            boosterAmount={this.state.boosterAmount}
            boosterType={this.state.boosterType}
            i18next = {i18next}
            >  
              
            
            </ReplayTable> : null}

         </div> 
        );
      }
    }

const mapStateToProps = state => {
  return {
    rangeBarValue: state.rangeBarValue,
    lang: state.header.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getRangeBarValue: (value) => dispatch(actions.getRangeBarValue(value))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReplayHand);


/** WEBPACK FOOTER **
 ** ./src/components/HandReplayer/ReplayHand.js
 **/